var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrendingPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_253_6964)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12C9.75 11.7894 10.7881 10.75 11 9.5",
    stroke: "#4B4AD5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7 6L8.64188 1.5C9.99125 2.62 13 5.50938 13 9C13 10.3261 12.4732 11.5979 11.5355 12.5355C10.5979 13.4732 9.32608 14 8 14C6.67392 14 5.40215 13.4732 4.46447 12.5355C3.52678 11.5979 3 10.3261 3 9C3 7.08938 3.90125 5.35875 4.9375 4L7 6Z",
    fill: "#4B4AD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 6L8.64188 1.5C9.99125 2.62 13 5.50938 13 9C13 10.3261 12.4732 11.5979 11.5355 12.5355C10.5979 13.4732 9.32608 14 8 14C6.67392 14 5.40215 13.4732 4.46447 12.5355C3.52678 11.5979 3 10.3261 3 9C3 7.08938 3.90125 5.35875 4.9375 4L7 6Z",
    stroke: "#4B4AD5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_253_6964"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendingPurple);
export default __webpack_public_path__ + "static/media/trending-purple.9d285fc39bae5c3f9df2dcf8a9c3a178.svg";
export { ForwardRef as ReactComponent };